import orderBy from "lodash/orderBy";

import type { ActivationItemSchema } from "app/pages/activation/components/ActivationSetDropdown/components/ActivationItem/types";
import type { ShortActivationSetSchema } from "app/pages/activation/types/api";
import CountryService from "app/services/CountryService";

export const activationSetSearch = (searchText: string, item: { props: ActivationItemSchema }) => {
    const { countryId, name, primaryDomain, competitors } = item.props;
    const countryText = CountryService.getCountryById(countryId)?.text;

    const predicate = searchText.toLowerCase();
    const searchList = [
        name?.toLocaleLowerCase(),
        countryText?.toLowerCase(),
        primaryDomain?.toLowerCase(),
        ...competitors.map((c) => c.toLowerCase()),
    ];

    if (searchList.some((sl) => sl?.includes(predicate))) {
        return item;
    }
};

export const selectSortedActivationSetList = (activationId: string) => (data: ShortActivationSetSchema[]) => {
    if (!data.length || !activationId) {
        return [];
    }

    const byName = (o: ShortActivationSetSchema) => o.name?.toLowerCase();
    const byCurrentSelected = (o: ShortActivationSetSchema) => o.id === activationId;

    return orderBy(data, [byCurrentSelected, "isFavorite", "isOwn", byName], ["desc", "desc", "desc", "asc"]);
};
